export const isMarketingAdminUser = (user) => {
  if (!user) return false;

  const role = (user?.role || "").toString().trim().toLowerCase();
  const email = (user?.email || "").toString().trim().toLowerCase();

  return role === "marketing_admin" || role === "marketing" || email === "marketing@ilmaivo.com";
};
